<form #form="ngForm" novalidate>
  <div class="modal-header">
    <h4 class="h4 modal-title">
      <span>{{ title }}</span>
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true"><i class="cc-icon cc-icon-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="px-5">
      <div class="form-group">
        <label for="name" class="default-label" i18n>Tag group name</label>
        <div [ngClass]="{ 'has-danger': submitted && name.invalid }">
          <input
            type="text"
            placeholder="Type name"
            i18n-placeholder="Type name"
            class="tag-name-input form-control"
            name="name"
            id="name"
            required
            #name="ngModel"
            [(ngModel)]="model.name"
            ccFocus
          />
          <div class="sm-text-default-red" i18n *ngIf="submitted && name.invalid">Name is required</div>
        </div>
      </div>
      <div>
        <label class="default-label" for="list-items" i18n>Tags</label>
        <div [ngClass]="{ 'has-danger': submitted && model.items.length === 0 }">
          <select
            class="add-tag-select form-control rounded-0 border-bottom-0"
            id="list-items"
            name="list-items"
            multiple
            required
            [(ngModel)]="selectedItems"
          >
            <option *ngFor="let item of model.items" [value]="item.id">{{ item.value }}</option>
          </select>
          <div class="sm-text-default-red" i18n *ngIf="submitted && model.items.length === 0">
            Tags are required
          </div>
        </div>
      </div>
      <div class="form-group">
        <input
          type="text"
          class="tag-input form-control rounded-0"
          placeholder="Type tag"
          name="new-tag-item"
          [(ngModel)]="newItem.value"
          i18n-placeholder="Type tag"
          #newItemRef
          (keyup.enter)="addItem()"
        />
        <div *ngIf="newItem.invalid">
          <div class="sm-text-default-red" i18n>
            Tag name can only contains letters, numbers, dashes and underscores.
          </div>
        </div>
      </div>
      <div class="form-group">
        <button type="button" class="float-left btn btn-secondary btn-add" i18n (click)="addItem()">
          Add
        </button>
        <button type="button" class="btn-remove float-right btn btn-secondary" i18n (click)="removeItem()">
          Remove
        </button>
        <span class="clearfix"></span>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-center">
    <button type="button" (click)="save()" class="btn-save btn btn-success" i18n>Save changes</button>
  </div>
</form>
